import type { ICard } from "../../cardsSlice";

export const major8Card: ICard = {
    id: "major_8",
    arcana: "major",
    number: 8,
    suit: "major",
    court: "major",
    name: "Сила",
    nameEn: "Strength",
    keywords: ["Мужество", "Терпение", "Внутренняя устойчивость"],
    symbolism: [
      "Женщина с венком открывает пасть льва",
      "Знак бесконечности над головой",
      "Белое одеяние, спокойное выражение"
    ],
    symbolismInterpretation:
      "Гармония силы и мягкости, укрощение инстинктов через внутреннюю уверенность",
    archetype: "Интеграция животной природы, архетип стойкости через сострадание",
    psychology: "Контроль над импульсами, терпение в сложных ситуациях",
    upright: {
      personality: "Великодушие, стойкость, мягкая уверенность",
      relationships: "Забота, преодоление конфликтов, доброжелательность",
      work: "Сила характера, выдержка, уравновешенность",
      spirituality: "Принятие своей природы, доверие к себе",
      examples: ["Созидательное использование силы", "Смелость быть мягким", "Смирение как сила"]
    },
    reversed: {
      meaning: "Агрессия, слабость, отсутствие контроля",
      nuances: "Страх, прикрываемый показной уверенностью"
    },
    associations: ["Терпение", "Самообладание", "Гармония", "Укрощение"],
    combinations: [
      "С Колесницей — баланс активного и пассивного управления",
      "С Луной — борьба с теневыми сторонами"
    ],
    readingTips: ["Оценить, где важна мягкость", "Не прятать страх за внешней уверенностью"],
    selfQuestions: ["Где моя сила?", "Чего я боюсь в себе самом?"]
  };


